import { render, staticRenderFns } from "./r-toggle-card.vue?vue&type=template&id=04f2a0d6"
import script from "./r-toggle-card.vue?vue&type=script&lang=js"
export * from "./r-toggle-card.vue?vue&type=script&lang=js"
import style0 from "./r-toggle-card.vue?vue&type=style&index=0&id=04f2a0d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./r-toggle-card.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports